import { all } from 'redux-saga/effects';
import contactSaga from './contactSaga';
import scanSaga from './scanSaga';
import subscribeSaga from './subscribeSaga';

export default function* rootSaga() {
  yield all([contactSaga(), scanSaga(), subscribeSaga()]);
}
